import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import { navigate } from "gatsby";

const Steps = () => {
  const [debtValue, setDebtValue] = useState(63000);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [formError, setFormError] = useState({
    debtValue: "",
    liveInTexas: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });
  const [values, setValue] = useState({
    debtValue: "",
    liveInTexas: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValue((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const handleSliderChange = (sliderEvent, newValue) => {
    setDebtValue(newValue);
    setValue({
      ...values,
      debtValue: newValue ? newValue : 63000,
    });
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setLoading(true);

    const url = window.location.href;
    const emailData = {
      subject: `Referer: [${url}]`,
      referer: url,
      fromName: `ADC Referer: ${url}`,
      toName: "there",
      googleUrlParameter: url,
      ...values,
    };

    emailjs
      .send(
        "service_p5cs97s",
        "template_c8tfhst",
        emailData,
        "PvTyuGGKn4qTGC0S7"
      )
      .then(
        (result) => {
          setLoading(false);
          setValue({
            debtValue: "",
            liveInTexas: "",
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
          });
          navigate("/next-step/");
        },
        (error) => {
          setLoading(false);
          console.log(error);
        }
      );
  };

  return (
    <div className="w-full text-center">
      {step === 1 ? (
        <Step1
          handleSliderChange={handleSliderChange}
          handleSubmit={handleSubmit}
          handleChange={handleChange}
          setFormError={setFormError}
          formError={formError}
          debtValue={debtValue}
          setStep={setStep}
          values={values}
          step={step}
        />
      ) : step === 2 ? (
        <Step2
          handleSubmit={handleSubmit}
          handleChange={handleChange}
          setFormError={setFormError}
          formError={formError}
          setStep={setStep}
          values={values}
          step={step}
        />
      ) : step === 3 ? (
        <Step3
          handleSubmit={handleSubmit}
          handleChange={handleChange}
          setFormError={setFormError}
          formError={formError}
          setLoading={setLoading}
          loading={loading}
          setStep={setStep}
          values={values}
          step={step}
        />
      ) : null}
    </div>
  );
};

export default Steps;
